import * as types from 'prop-types';

export const FooterOptions = {
  form: types.bool,
  formId: types.string,
  submitLabel: types.string,
  submitButtonComponent: types.func,
  backRoute: types.string,
  disabled: types.bool,
  selectButton: types.string,
  showFooter: types.bool,
  variation: types.oneOf(['default', 'simpliest'])
}